// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"55a771d2","237":"a0d5cd40","483":"72421e5b","624":"36e6292d","670":"f25121dc"}[chunkId] + ".chunk.css";
};